<template>
  <div class="angel-fund-project-list">
    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        :summary-method="summaryMethod"
        @search-reset="searchResets"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        :header-cell-class-name="headerClassName"
      >
        <template slot="projectName" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">{{ row.projectName }}</div>
        </template>        
      </avue-crud>
    </div>
  </div>
</template>
<script>
import { fundProjectListConfig } from "../config.js";
import { getFundList, getFundListTotal } from "@/api/fund/fundProject";

import { mapGetters } from "vuex";
import util from "@/mixins/util";
export default {
  name: "FundProjectListComponent",
  mixins: [util],
  data() {
    return {
      totalData: "",
      tableData: [],
      dialogType: 1,
      formData: {},
      dialogShow: false,
      selectionList: [],
      tableConfig: fundProjectListConfig(this.getMoney),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
    };
  },
  components: {},
  watch: {
    // isEdit: {
    //   handler(newValue, oldValue) {
    //     if(newValue == true) {
    //       this.tableConfig.selection = true
    //       this.queryTableData()
    //     }
    //   },
    //   immediate: true
    // }
    fundId: {
      handler(newValue, oldValue) {
        if (newValue > -1) {
          this.queryTableData();
        }
      },
      immediate: true,
    },
  },
  props: {
    fundId: {
      type: String,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    bizType: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  mounted() {
    if (this.bizType != 1) {
      this.tableConfig.column[5].display = false;
    }
  },
  methods: {
    goDetail(row) {
      this.$router.push({path: `/fund/fundProjectManage/detail?id=${row.id}`})
    },

    headerClassName(tab){
       
       return 'avue_bgc';
     },
    summaryMethod({ columns, data }) {
      const self = this;
      const sums = [];
      // let arrays = this.tableConfig.selection?[5,6,7,9]:[4,5,6,8]
      let arrays = this.bizType == 1 ? ['fundAmount', 'societyAmount', 'govIndustryAmount'] : ['fundAmount', 'societyAmount'];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (arrays.includes(column.property)) {
            // 赋值totalData
            sums[index] = self.getMoney(Math.round(Number(self.totalData[column.property])*100)/100)
          } else {
            sums[index] = "";
          }
        });
      }
      sums[0]="合计:"
      return sums;
    },
    selectionChange(data) {
      this.selectionList = data;
    },

    searchChange(query, done) {
      this.searchForm = {...this.searchForm,...query};
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },

    async queryTableData() {
      if (!this.fundId) {
        return;
      }
      let params = {
        fundId: this.fundId,
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        bizType: this.bizType,
      };
      let res = {};
      res = await getFundList(params);

      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
        let params = {
          fundId: this.fundId,
          current: this.page.currentPage,
          size: this.page.pageSize,
          ...this.searchForm,
        };
        let totalData = await getFundListTotal(params);
        this.totalData = totalData.data.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.angel-fund-project-list {
  .project-name {
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }  
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  .manage-table {
    background: #ffff;
    // padding: 25px;
  }
  .project-name {
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  /deep/.el-badge__content {
    line-height: 17px;
    padding: 0 5px;
    z-index: 29;
  }
  .el-table__fixed, .el-table__fixed-right {
      height: calc(100% - 0px) !important;
  }
  /deep/.el-table {
    display: flex !important;
    flex-direction: column !important;
  }
  //  order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 
  /deep/.el-table__body-wrapper {
    order: 1 !important;
  }

  /deep/.el-table__fixed-footer-wrapper{
    top: 40px !important;
    z-index: 0;
  }
  /deep/.el-table__fixed-body-wrapper{
    top: 80px !important
  }
}
/deep/ .right_radio .el-radio-button__inner {
    border-left: 0;
    border-radius: 0 4px 4px 0;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;

}
/deep/ .center_radio .el-radio-button__inner {
    border-left: 0;
    border-radius: 0;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;

}
.fund-right-content {
  .right-btn {
    margin-left: 0 !important;
    margin-bottom: 10px;
    width: 100%;
    color: black;
    font-size: 14px;
  }
  .right-btn:hover {
    color: #64b0ff;
  }
}
.plus-right {
  color: #f56c6c !important;
  font-weight: 600;
  font-size: 16px;
}
/deep/.ant-popover-placement-right{
  width: 170px !important;
}
/deep/ .el-table .cell, /deep/ .el-table th>.cell {

    padding-left:0px;
    padding-right: 0px;

}
/deep/ .el-table .cell {
   font-size:14px;

}
// /deep/ .el-table__fixed-footer-wrapper{
//     display: none !important;
// }

/deep/.el-table__footer-wrapper,/deep/.el-table__fixed-footer-wrapper {
   .cell {
      color:red
    }
 }
 /deep/.avue_bgc{
  background: #F6FAFF !important;
  font-weight: 400 !important;
}

// /deep/.el-table td {
//   padding:12px 0 !important
// }
/deep/ .el-table {
    border-color: #e0eeff;
}
/deep/.avue-crud {
    width:100%
  }
</style>
<style lang="scss">
.ant-popover-placement-right{
  width: 170px !important;
}


</style>

